import CalendarStore from 'mini-calendar-store/lib/store/schema/CalendarStore';
import getStore from 'mini-calendar-store/lib/store/store';
import { mutatorAction } from 'satcheljs';

/**
 * Mutator to toggle calendar selection
 */
const toggleCalendarSelection = mutatorAction('toggleCalendarSelection', (calendarId: string) => {
    const calendarStore: CalendarStore = getStore();
    const calendar = calendarStore.calendarIdToCalendarMapping.get(calendarId);
    if (calendar) {
        calendar.isSelected = !calendar.isSelected;
    }
});

export default toggleCalendarSelection;
